import CustomSelection from './custom-selection';

export default class Tournament extends CustomSelection {
  constructor(options) {
    super(options);
    this.idSport = options.id_sport;
    this.categoryIso = (options.category_iso || 'INT').toLowerCase();
    this.category = options.category;
    this.isOutright = options.providerId
      ? options.providerId.charAt(0) === 'O' : false;
    this.betTemplate = options.betTemplate || {};
  }

  resetBetTemplate() {
    this.betTemplate = {};
  }
}
